<template>
  <div>
    <!-- 货架管理 -->
    <baseBreadcrumb :page="$t('message.shelfManagement')" :menu="$t('message.warehouse')"></baseBreadcrumb>
    <div class="body">
      <!-- 页签、筛选和批量操作固定在页面顶部，滚动列表时保持可操作。 -->
      <div class="shelf-sticky-toolbar">
        <div class="tab-row">
          <el-tabs v-model="datas.status" type="card" @tab-click="handleClick">
            <!-- 全部区域 -->
            <el-tab-pane name="" :label="$t('message.allAreas')"></el-tab-pane>
            <!-- 使用中 -->
            <el-tab-pane name="2" :label="$t('message.inUse') + `(${tabs[1].num})`"></el-tab-pane>
            <!-- 停用 -->
            <el-tab-pane name="1" :label="$t('message.disable')"></el-tab-pane>
          </el-tabs>
          <div class="btn">
            <!-- 批量开启 -->
            <el-button type="primary" v-if="isAuth(362)" @click="batchSetShelfShow(1)">
              {{ $t("message.batchOpen") }}
            </el-button>
            <!-- 批量关闭 -->
            <el-button type="primary" v-if="isAuth(362)" @click="batchSetShelfShow(0)">
              {{ $t("message.batchClose") }}
            </el-button>
            <!-- 批量删除 -->
            <el-button type="danger" v-if="isAuth(361)" @click="batchShelfDelete" class="dark">
              {{ $t("message.batchDeletion") }}
            </el-button>
            <!-- 批量设置货架使用人 -->
            <el-button type="primary"  @click="openBatchShelfUser">
              {{ $t("message.batchSetShelfUser") }}
            </el-button>
            <!-- 批量创建系统货架 -->
            <el-button type="success" @click="add" v-if="isAuth(359)">
              {{ $t("message.batchCreateSystemShelf") }}
            </el-button>
          </div>
        </div>
        <!-- 搜索 -->
        <div class="head">
          <div class="search">
            <div class="input">
              <!-- 范围与使用人员独立选择，均使用当前账号权限层级下的数据。 -->
              <el-cascader v-model="datas.org_id" :options="adminOrganization" :props="{
                expandTrigger: 'hover',
                label: 'name',
                value: 'id',
                children: 'childs',
                checkStrictly: true,
                emitPath: false,
              }" :placeholder="$t('message.scopeOfPersonnel')" filterable clearable @change="onOrgChange" />
            </div>
            <div class="input">
              <!-- 使用人员 -->
              <el-select v-model="datas.admin_id" :placeholder="$t('message.shelfUserPersonnel')" filterable clearable
                @change="onAdminChange">
                <el-option v-for="item in dataUserList" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!--  货架编号-->
            <div class="input">
              <el-input :placeholder="$t('message.shelfNumber')" v-model="datas.shelf_number" clearable
                onfocus="this.select()"></el-input>
            </div>
            <!--  货架备注-->
            <div class="input">
              <el-input :placeholder="$t('message.shelfRemarks')" v-model="datas.remark" clearable
                onfocus="this.select()"></el-input>
            </div>
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection">
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>

          <el-table-column align="center" label="NO" width="80" prop="rowNumber">
          </el-table-column>
        
         
            <!-- 货架编号 -->
            <el-table-column align="center" :label="$t('message.shelfNumber')" prop="shelf_number" width="200px">
              <template slot-scope="scope">
               {{ scope.row.wms_area.wms_area_type.code }}-{{ scope.row.shelf_number }}

              </template>
          </el-table-column>
            <!-- 货架类别 -->
            <el-table-column align="center" :label="$t('message.categoryOfShelves')" prop="shelf_type_name">
          </el-table-column>
             <!-- 用途 -->
             <el-table-column align="center" :label="$t('message.use')" prop="wms_area.wms_area_type.type">
          </el-table-column>
          <!-- 区域尺寸(米) -->
          <el-table-column align="center" :label="$t('message.areaSizeM')" prop="rowNumber" width="150px">
            <template slot-scope="scope" v-if="scope.row.wms_area">
              {{ scope.row.wms_area.c }} * {{ scope.row.wms_area.k }} *
              {{ scope.row.wms_area.g }}
            </template>
          </el-table-column>
          <!-- 属性 -->
          <!-- <el-table-column align="center" :label="$t('message.property')" prop="range_type_name">
          </el-table-column> -->
        

       
          <!-- 货架尺寸.米 -->
          <el-table-column align="center" :label="$t('message.shelfSizeMeters')" prop="floor" width="150">
            <template slot-scope="scope">
              {{ scope.row.c }} * {{ scope.row.k }} * {{ scope.row.g }}
            </template>
          </el-table-column>
             <!-- 货架使用范围 -->
             <el-table-column align="center" :label="$t('message.rangeOfUseOfShelf')" prop="range">
            <template slot-scope="scope">
              <span v-if="scope.row.admin">
                {{ scope.row.admin.realname }}</span>
              <span v-if="scope.row.organization">
                {{ scope.row.organization.name }}</span>
            </template>
          </el-table-column>
          
          <!-- 货架层数：每层库位数 -->
          <el-table-column align="center" :label="$t('message.shelfLayerNumber')" min-width="140">
            <template slot-scope="scope">
              <div class="floor-list">
                <p v-for="item in getDescendingFloorGrids(scope.row.floor_grids)" :key="item.floor">
                 <span  style="margin-right: 10px;">{{ item.floor }}层</span> {{ item.grid_count }}
                </p>
              </div>
            </template>
          </el-table-column>

          <!-- 使用状态 -->
          <el-table-column align="center" :label="$t('message.statusOfUse')" width="100px">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_show" active-color="#2C96E7 " @change="setShelfShow(scope.row)"
                :disabled="!isAuth(362)">
              </el-switch>
            </template>
          </el-table-column>
            <!-- 货架备注 -->
            <el-table-column align="center" :label="$t('message.remarksOnShelves')" prop="remark">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="140px">
            <template slot-scope="scope">
              <!-- 设置货架使用人 -->
              <p style="margin-bottom: 10px">
                <el-button type="primary" class="primary" size="small" @click="openShelfUser(scope.row)" >{{
                  $t("message.setShelfUser")
                }}</el-button>
              </p>
              <!-- 修改 -->
              <p style="margin-bottom: 10px">
                <el-button type="primary" class="primary" size="small" @click="edit(scope.row)" v-if="isAuth(360)">{{
                  $t("message.edit")
                }}</el-button>
              </p>
              <!-- 删除 -->
              <el-button type="success" class="dark" size="small" @click="shelfDelete(scope.row.shelf_number)"
                v-if="isAuth(361)">{{
                  $t("message.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 200, 500, 1000]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 货架设置弹框 -->
    <shelf-setting-dialog ref="shelfSettingDialog" @saved="onShelfSaved" />
    <!-- 设置货架使用人弹框 -->
    <set-shelf-user-dialog ref="setShelfUserDialog" @saved="onShelfSaved" />
  </div>
</template>
<script>
import shelfSettingDialog from './components/shelfSettingDialog'
import setShelfUserDialog from './components/setShelfUserDialog'
export default {
  components: {
    shelfSettingDialog,
    setShelfUserDialog,
  },
  data() {
    return {
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 },],
      activeName: "1",
      datas: {
        page: 1,
        pageSize: 100,
        area_number: "",
        shelf_number: "",
        shelf_type: "",
        range: "",
        org_id: "",
        admin_id: "",
      },
      adminOrganization: [],
      dataUserList: [],
      total: 0,
      tableData: [],
      selectList: [],
    };
  },
  created() {
    this.loadUserOptions()
    this.shelfList();
    this.wmsShelfNum()
  },
  methods: {
    // 货架层数仅在列表中按层号倒序展示，不改变接口原始数据。
    getDescendingFloorGrids(floorGrids) {
      return (floorGrids || []).slice().sort((a, b) => Number(b.floor) - Number(a.floor))
    },

    // 仓库货架列表统计
    wmsShelfNum() {
      this.$api.tabTotalApi.wmsShelfNum().then(res => {
        this.tabs = res.data
      })
    },
    shelfList() {
      this.$api.warehouseApi.shelfList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.is_show = item.is_show == 1 ? true : false;
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.shelfList();
    },
    // 切换状态
    handleClick() {
      this.datas.page = 1;
      this.shelfList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.shelfList();
    },
    handleSizeChange(val) {
      this.datas.page = 1
      this.datas.pageSize = val;
      this.shelfList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    //货架-是否显示
    setShelfShow(item) {
      let datas = {
        shelf_number: item.shelf_number,
        is_show: item.is_show ? 1 : 0,
      };
      this.$api.warehouseApi.setShelfShow(datas);
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 勾选后循环调用货架显示接口
    batchSetShelfShow(is_show) {
      if (!this.selectList.length) return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"));
      const requests = [];
      this.selectList.forEach((item) => {
        requests.push(this.$api.warehouseApi.setShelfShow({
          shelf_number: item.shelf_number,
          is_show,
        }));
      });
      Promise.all(requests).then(() => {
        this.shelfList();
        this.wmsShelfNum();
      });
    },
    // 勾选后循环调用删除接口
    batchShelfDelete() {
      if (!this.selectList.length) return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"));
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          const requests = [];
          this.selectList.forEach((item) => {
            requests.push(this.$api.warehouseApi.shelfDelete({
              shelf_number: item.shelf_number,
            }));
          });
          Promise.all(requests).then((res) => {
            this.$message.success(res[0] && res[0].msg);
            this.shelfList();
            this.wmsShelfNum();
          });
        })
        .catch(() => { });
    },
    add() {
      this.$refs.shelfSettingDialog.open()
    },
    edit(item) {
      let data = JSON.parse(JSON.stringify(item))
      this.$refs.shelfSettingDialog.open(data)
    },
    openShelfUser(item) {
      this.$refs.setShelfUserDialog.open(item)
    },
    openBatchShelfUser() {
      if (!this.selectList.length) return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"))
      this.$refs.setShelfUserDialog.openBatch(this.selectList)
    },
    onShelfSaved() {
      this.shelfList()
      this.wmsShelfNum()
    },
    // 删除货架
    shelfDelete(shelf_number) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.warehouseApi.shelfDelete({ shelf_number }).then((res) => {
            this.$message.success(res.msg);
            this.shelfList();
            this.wmsShelfNum()
          });
        })
        .catch(() => { });
    },
    // 与设置货架使用人使用相同数据源，人员选项不随筛选范围联动。
    loadUserOptions() {
      this.$api.roleApi.getAdminOrganization().then((res) => {
        this.adminOrganization = res.data || []
      })
      this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then((res) => {
        this.dataUserList = res.data || []
      })
    },
    // 两个条件二选一，清空时统一使用空字符串提交。
    onOrgChange(value) {
      this.datas.org_id = value || ''
      if (value) this.datas.admin_id = ''
    },
    onAdminChange(value) {
      if (value) this.datas.org_id = ''
    },
  },
};
</script>
<style lang='scss' scoped>
.body {
  --shelf-sticky-toolbar-height: 118px;
}

// 顶部操作区跟随 el-main 滚动容器吸顶，不覆盖系统顶部导航。
.shelf-sticky-toolbar {
  position: sticky;
  top: 0;
  z-index: 30;
  min-height: var(--shelf-sticky-toolbar-height);
  background: #fff;
}

.tab-row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/.el-tabs {
    flex: 1;
    min-width: 0;
  }

  /deep/.el-tabs__header {
    margin-bottom: 0;
  }

  .btn {
    flex-shrink: 0;
    margin-left: 16px;
  }
}

.head {
  margin: 14px 0 24px;

  .search {
    display: flex;

    .input {
      width:180px;
      margin-right: 10px;

      .el-select,
      .el-cascader {
        width: 100%;
      }
    }
  }
}

.table {
  overflow: visible;

  // Element Table 默认 overflow 会阻断 sticky，需要释放表格外层并单独吸附表头。
  /deep/.el-table {
    overflow: visible;
  }

  /deep/.el-table__header-wrapper {
    position: sticky;
    top: var(--shelf-sticky-toolbar-height);
    z-index: 29;
    background: #edeff4;
  }
}

.floor-list {
  p {
    margin: 0;
    line-height: 20px;
  }
}
</style>
